import { captureException } from '@playbookux/playbook-web-core';
import { createEvent } from 'ics';
import moment from 'moment';

const toDateArray = (d) => {
  const date = moment(d).utc();

  return date
    .format('YYYY-M-D-H-m')
    .split('-')
    .map((value) => parseInt(value, 10));
};

const generateICSFile = ({
  summary,
  description,
  location,
  startAt,
  endAt,
}) => {
  const event = {
    location,
    description,
    title: summary,
    start: toDateArray(startAt),
    end: toDateArray(endAt),
    startInputType: 'utc',
    endInputType: 'utc',
  };

  return new Promise((resolve, reject) => {
    createEvent(event, (error, value) => {
      if (error) {
        reject(error);
        captureException('ICALENDAR_CREATE_EVENT_ERROR', error);
        return;
      }

      resolve(value);
    });
  });
};

export { generateICSFile };
